document.addEventListener('DOMContentLoaded', () => {

const mobileFilter = document.querySelector('.recipe-mobile-filter');
const mobileBreakpoint = window.matchMedia('(max-width: 767px)');

function updateRecipeFilterState(event) {
  if (!mobileFilter) return;

  if (event.matches) {
    mobileFilter.removeAttribute('open');
  } else {
    mobileFilter.setAttribute('open', '');
  }
}

if (mobileFilter) {
  updateRecipeFilterState(mobileBreakpoint);
  mobileBreakpoint.addEventListener('change', updateRecipeFilterState);
}

  
  const filters = document.querySelectorAll('.recipe-filter');
  const cards = document.querySelectorAll('.recipe-card');

  if (!filters.length || !cards.length) return;

function normalizeTag(value) {
  return value
    .toLowerCase()
    .trim()
    .replace(/[®™©]/g, '')
    .replace(/&reg;|&trade;|&copy;/g, '')
    .replace(/\s+/g, ' ');
}

  function filterRecipes() {

    const selected = [...filters]
      .filter(filter => filter.checked)
      .map(filter => normalizeTag(filter.value));

    let visibleCount = 0;

    cards.forEach(card => {

      const tags = (card.dataset.tags || '')
        .split('|')
        .map(tag => normalizeTag(tag));

      if (selected.length === 0) {

        card.style.display = '';
        visibleCount++;
        return;

      }

      const matches = selected.every(tag => tags.includes(tag));

      card.style.display = matches ? '' : 'none';

      if (matches) {
        visibleCount++;
      }

    });

    const counter = document.getElementById('recipe-count');

    if (counter) {
      counter.textContent =
        `Showing ${visibleCount} recipe${visibleCount === 1 ? '' : 's'}`;
    }

  }

  filters.forEach(filter => {
    filter.addEventListener('change', filterRecipes);
  });

  filterRecipes();

});